import React from "react";
import Header from "@/components/header";
import Footer from "@/components/footer";
import CallToAction from "@/components/call-to-action";
import Head from "next/head";
import { ArrowSquareOutIcon } from "@phosphor-icons/react";

import ShippingCalculatorFeatures from "@/components/shipping-calculator-features";
import ShippingCalculatorDemo from "@/components/shipping-calculator-demo";

import { motion } from "framer-motion";
import { titleInitial, titleAnimate } from "@/components/animations";
import { Button } from "@/components/ui/button";
import Link from "next/link";
import MapBackground from "@/components/map-background";

// Force SSR to avoid framer-motion static generation issues
export async function getServerSideProps() {
  return { props: {} };
}

export default function ShippingRates() {
  return (
    <>
      <Head>
        <title>Partbot - Shipping Rates Module</title>
      </Head>
      <Header />
      <main>
        <MapBackground />
        <div className="relative flex min-h-[90dvh] flex-col items-end justify-end pt-24">
          <div className="container mx-auto">
            <div className="relative">
              <div className="mt:py-16 relative grid gap-10 px-6 py-6 lg:grid-cols-2 lg:items-center xl:px-6">
                <div className="lg:pb-8">
                  <motion.h1
                    initial={titleInitial}
                    whileInView={titleAnimate()}
                    viewport={{ once: true }}
                    className="text-balance bg-linear-to-r pb-5 text-4xl font-bold leading-none drop-shadow-lg text-stone-50 lg:text-6xl xl:text-7xl"
                  >
                    Real-time Shipping Rates
                  </motion.h1>
                  <motion.div
                    initial={titleInitial}
                    whileInView={titleAnimate(0.25)}
                    viewport={{ once: true }}
                    className="prose mt-3 max-w-prose text-balance text-emerald-300/75 md:mt-6"
                  >
                    <p className="text-lg">
                      Provide your customers with real-time shipping rates from your distributors on your product pages and at checkout.
                    </p>
                  </motion.div>
                  <motion.div
                    initial={titleInitial}
                    whileInView={titleAnimate(0.5)}
                    viewport={{ once: true }}
                    className="mt-9 hidden items-center space-x-5 md:flex"
                  >
                    <Button
                      asChild
                      className="bg-emerald-500 md:mt-0"
                    >
                      <Link
                        href="https://shipping-calculator.partbot.io"
                        target="_blank"
                      >
                        <span>View Calculator Documentation</span>
                        <ArrowSquareOutIcon />
                      </Link>
                    </Button>
                  </motion.div>
                </div>
                <motion.div
                  initial={titleInitial}
                  whileInView={titleAnimate(0.75, 1.5)}
                  viewport={{ once: true }}
                  className="relative flex flex-col items-end justify-start px-0 pt-4 md:pt-2 lg:-mt-10 lg:pt-0"
                >
                  <ShippingCalculatorDemo />
                  <div className="mt-6 flex w-full items-center space-x-5 md:hidden">
                    <Button className="w-full md:w-auto" asChild>
                      <Link
                        href="https://shipping-calculator.partbot.io"
                        target="_blank"
                      >
                        <span>View Calculator Documentation</span>
                        <ArrowSquareOutIcon />
                      </Link>
                    </Button>
                  </div>
                </motion.div>
              </div>
            </div>
          </div>
        </div>
        <ShippingCalculatorFeatures />

        <CallToAction />
      </main>
      <Footer />
    </>
  );
}
